import React from 'react';

import './styles.css';

const AppLogoSVG = ({ height, width, animation, isIcon }) => {
  let animationClasses = '';
  let classes = 'iconApp w-2/12 max-w-[150px] mb-5';
  if (animation) {
    animationClasses = 'animation-app-icon';
  }
  if (isIcon) {
    classes = 'iconApp';
  }
  return (
    <>
      <svg
        className={classes}
        preserveAspectRatio="xMidYMid meet"
        data-bbox="20 46.333 160 107"
        viewBox="20 46.333 160 107"
        height={height}
        width={width}
        xmlns="http://www.w3.org/2000/svg"
        data-type="color"
        role="img"
        aria-label="Homepage"
      >
        <g>
          <path
            className={animationClasses}
            d="M73.333 46.333h53.334l-53.334 107H20l53.333-107z"
            fill="#D6DCDC"
            data-color="1"
          ></path>
          <path
            className={animationClasses}
            d="M73.333 46.333zM100 99.833l26.667 53.5H180l-26.666-53.5H100z"
            fill="#D6DCDC"
            clipRule="evenodd"
            fillRule="evenodd"
            data-color="1"
          ></path>
        </g>
      </svg>
    </>
  );
};

export default AppLogoSVG;
